import React, { useEffect, useRef } from "react";
import { Navigate } from "react-router-dom";
import { toast } from "react-toastify";
import { getRoleFromToken } from "../utils/roleUtils";

const AdminPrivateRoute = ({ children }) => {
    const token = localStorage.getItem("user");
    const hasShownToast = useRef(false);

    const roleInfo = getRoleFromToken(token);

    // Show toast for non-admin users trying to access admin routes
    useEffect(() => {
        if (token && roleInfo && !roleInfo.isAdmin && !hasShownToast.current) {
            hasShownToast.current = true;
            toast.error("Access denied. Admin privileges required.", {
                position: toast.POSITION.TOP_RIGHT,
            });
        }
    }, [token, roleInfo]);

    if (!token) {
        return <Navigate to="/login" replace />;
    }

    if (!roleInfo) {
        // Invalid token
        return <Navigate to="/login" replace />;
    }

    if (!roleInfo.isAdmin) {
        return <Navigate to="/" replace />;
    }

    return children;
};

export default AdminPrivateRoute;
